import AcxMainTextField from "components/UI/AcxMainTextField";
import AcxSelectSingle from "components/UI/Select/BaseSelectComponents/AcxSelectSingle";
import { observer } from "mobx-react";
import { LLMExecutorStep } from "models/LLMs";
import React, { useMemo } from "react";

type StepVariableSelectorProps = {
    step: LLMExecutorStep;
    variable: string;
    onChange: (variableName: string) => void;
};

export const StepOutputVariableSelector = observer(function (
    props: StepVariableSelectorProps,
) {
    const variableOptions = useMemo(() => {
        const variables =
            props.step.configuration.getPotentialOutputVariables() ?? [];
        return variables.map((variable) => ({
            label: variable,
            value: variable,
        }));
        // Disabled exhaustive-deps because we want to re-extract variables if the prompt itself changes
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.step.configuration.prompt]);

    if (variableOptions.length > 0)
        return (
            <AcxSelectSingle
                id=""
                fullWidth
                labelField="label"
                valueField="value"
                placeholder="Select variable..."
                options={variableOptions}
                defaultValue={
                    !!props.variable
                        ? { label: props.variable, value: props.variable }
                        : undefined
                }
                onChange={(option) => props.onChange(option.label)}
            />
        );

    return (
        <AcxMainTextField
            id=""
            fullWidth
            placeholderText="Enter variable name..."
            value={props.variable}
            onChange={(event) => {
                const value = event.target.value;
                props.onChange(value);
            }}
        />
    );
});
